// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ImageViewer from './data'

export default function ImageViewerFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ImageViewer">
      <ImageViewer {...props}>
        {children}
      </ImageViewer>
    </Flow>
  )
}
